import { AdminMessage } from "@components/admin/admin-helpers"
import { createBlock, defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Film Note",
  tags: ["film-text"],
  icon: "format-aside",
  description: "The long description of the film, imported from Ferve.",
  category: "Film",
  conditions: {
    multiple: false,
    postTypes: ["film"],
  },
}

export default defineBlock("film/film-note", (props) => {
  if (!props.film?.descriptions?.note) {
    if (env.admin) {
      return <AdminMessage>No note has been attached to this film</AdminMessage>
    }
    return null
  }
  return (
    <div
      className="type-body-m bg-grey8 text-center text-pretty py-4 px-4 wysiwyg my-6 [&_>_*]:!mb-0 [&_hr]:!my-2 [&_hr]:opacity-20"
      dangerouslySetInnerHTML={{ __html: props.film?.descriptions?.note ?? "" }}
    />
  )
})
